export default {
    props: {
        config: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            translatable_object: {}
        };
    },

    computed: {
        title() {
            return this.getT9Label('title');
        },

        subtitle() {
            return this.getT9Label('subtitle');
        },

        bottom() {
            return this.getT9Label('bottom');
        },
    },

    methods: {
        getT9Label(key, obj = this.translatable_object) {
            return this.$utils.locales.getTranslatedLabel({ obj, key, preferredLocale: this.$i18n.locale, workspaceLocales: this.config.event_details.languages });
        },

        hasFpI18n(obj = this.translatable_object) {
            return Object.keys(obj.fp_i18n || {}).length > 0;
        }
    }
};
